/**
 * The type of mobile app
 */
export var ClientPlatformType;
(function (ClientPlatformType) {
    ClientPlatformType["CLIENT_PLATFORM_TYPE_UNKNOWN"] = "CLIENT_PLATFORM_TYPE_UNKNOWN";
    ClientPlatformType["CLIENT_DESKTOP"] = "CLIENT_DESKTOP";
    ClientPlatformType["CLIENT_MOBILE_WEB"] = "CLIENT_MOBILE_WEB";
    ClientPlatformType["APP_IOS"] = "APP_IOS";
    ClientPlatformType["APP_ANDROID"] = "APP_ANDROID";
    ClientPlatformType["APP_OTHER"] = "APP_OTHER";
})(ClientPlatformType || (ClientPlatformType = {}));
